module.exports = __webpack_public_path__ + "db8210d2bb48d3d451e10e3a920cd63c.woff2";